import type { FunctionComponent } from "react"

import { useSearchParams } from "next/navigation"

import { TagCTA } from "@jobteaser/ui-kit/components/Tag"

import { useCompanyFetch } from "@/modules/companies/client/hooks/useCompanyFetch"
import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { useJobAdsFilterNavigation } from "@/modules/jobAds/client/hooks/useJobAdsFilterNavigation"

export const JobAdsGroupFilter: FunctionComponent = () => {
  const { t } = useTranslation(["companies_client"])
  const { navigateWithUpdatedQueryParams } = useJobAdsFilterNavigation()
  const searchParams = useSearchParams()
  const { dataCompany } = useCompanyFetch()

  const isSelected = searchParams.has("groupOffers")
  const associatedCompanies = dataCompany?.page.associatedCompanies || []
  const associatedCompaniesCanDisplayJobs =
    dataCompany?.page.associatedCompanies.filter(associatedCompany => associatedCompany.displayJobs) || []

  const applyFunctionFilter = (newValue: boolean): void => {
    if (isSelected !== newValue) {
      navigateWithUpdatedQueryParams({
        availableFilters: { groupOffers: newValue ? "hide" : "" },
      })
    }
  }

  if (associatedCompanies.length === 0 || associatedCompaniesCanDisplayJobs.length === 0) {
    return null
  }

  return (
    <TagCTA
      isSelected={!isSelected}
      onClick={() => applyFunctionFilter(!isSelected)}
      data-testid="job_ads_groupOffers_filter"
    >
      {t("companies_client.jobAds.filter.groupOffers", { name: dataCompany?.page.name || "" })}
    </TagCTA>
  )
}
